<script setup>
import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { format } from 'date-fns';
import Dialog from 'dashboard/components-next/dialog/Dialog.vue';

const props = defineProps({
  pendingMove: {
    type: Object,
    default: null,
  },
  isLoading: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['confirm', 'close']);

const { t } = useI18n();
const dialogRef = ref(null);

const description = computed(() => {
  if (!props.pendingMove) return '';
  const { event, fromDay, toDay } = props.pendingMove;
  return t('CALENDAR.MOVE_EVENT.DESCRIPTION', {
    contactName: event.contactName,
    attributeName: event.attributeName,
    fromDate: format(fromDay, 'PPP'),
    toDate: format(toDay, 'PPP'),
  });
});

const open = () => dialogRef.value?.open();
const close = () => dialogRef.value?.close();

defineExpose({ open, close });
</script>

<template>
  <Dialog
    ref="dialogRef"
    type="edit"
    :title="t('CALENDAR.MOVE_EVENT.TITLE')"
    :description="description"
    :confirm-button-label="t('CALENDAR.MOVE_EVENT.CONFIRM')"
    :is-loading="isLoading"
    @confirm="emit('confirm')"
    @close="emit('close')"
  />
</template>
